/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformsubmit2Inputs */

const en_outcomeformsubmit2 = /** @type {(inputs: Outcomeformsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const pt_outcomeformsubmit2 = /** @type {(inputs: Outcomeformsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Outcomeformsubmit2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsubmit2 = /** @type {((inputs?: Outcomeformsubmit2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsubmit2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsubmit2(inputs)
	return pt_outcomeformsubmit2(inputs)
});
export { outcomeformsubmit2 as "outcomeFormSubmit" }